const event = new Event("rolex-map-loaded");

var rolexMapsLastCenter = null; // Mémoriser la position initiale
var rolexMapsLastMarkerCenter = null;
function initRolexMap() 
{
  jQuery('#rolex-contact-map').removeClass('placeholder');
  jQuery('#rolex-contact-map').find('.placeholder-action').remove();
  // Basic options for a simple Google Map
  // For more options see: https://developers.google.com/maps/documentation/javascript/reference#MapOptions
  var mapOptions = {
    // How zoomed in you want the map to start at (always required)
    zoom: 13,


    // The latitude and longitude to center the map (always required)
    center: new google.maps.LatLng(48.87,2.32),

    streetViewControl: false, // Masquer le bonhomme jaune (Pegman)
    mapTypeControl: false, // Masquer les boutons "Plan" et "Satellite"
    fullscreenControl: false, // Masquer le bouton plein écran
    disableDefaultUI: true,
    maxZoom: 19,


    // How you would like to style the map. 
    // This is where you would paste any style found on Snazzy Maps.
    styles: [
      {
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#f5f5f5"
          }
        ]
      },
      {
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#616161"
          }
        ]
      },
      {
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#f5f5f5"
          }
        ]
      },
      {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#bdbdbd"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#eeeeee"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels.text",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "featureType": "poi.business",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#cfe1d3"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#ffffff"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#dadada"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#616161"
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      },
      {
        "featureType": "transit",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#e5e5e5"
          }
        ]
      },
      {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#eeeeee"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#c2d9e1"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          },
          {
            "visibility": "simplified"
          }
        ]
      }
    ]
  };   
  rolexMapsLastCenter = mapOptions.center; // Mémoriser la position initiale
  rolexMapsLastMarkerCenter = mapOptions.center;

  var mapElement = document.getElementById('rolex-contact-map');

  // Badges de qualification affiches dans la popup d'une boutique. Les libelles
  // viennent de la section (data-attributes) pour rester alignes sur les badges
  // de la liste ; s'ils sont absents, aucun badge n'est rendu.
  var storeTags = [
    { label: mapElement.getAttribute('data-tag-retailer') || '', style: '' },
    { label: mapElement.getAttribute('data-tag-service') || '', style: 'gold' }
  ];

  // Create the Google Map using our element and options defined above
  var map = new google.maps.Map(mapElement, mapOptions); 

  // Create the DIV to hold the control and call the ZoomControl() constructor
  // passing in this DIV.
  var zoomControlDiv = document.createElement('div');
  var zoomControl = new ZoomControl(zoomControlDiv, map);

  zoomControlDiv.index = 1;
  map.controls[google.maps.ControlPosition.TOP_RIGHT].push(zoomControlDiv);

  var Shop=[];
  Shop.push({lib:'Arije Boutique Rolex Etoile',geo:new google.maps.LatLng(48.868760,2.302060), ad:"48 Rue Pierre Charron<br>75008 Paris<br>France",tel:"+33 1 47 20 48 48",img:"https://cdn.shopify.com/s/files/1/0767/8237/1000/files/rolex-etoile_d8fb091e-7660-4fa7-9993-e025fedc1d87.jpg?v=1737021398",plus:Shopify.routes.root + "pages/rolex-contact-arije-rolex-etoile",tags:storeTags});
  Shop.push({lib:'Arije Flagship',geo:new google.maps.LatLng(48.868860,2.302270), ad:"50 Rue Pierre Charron<br>75008 Paris<br>France",tel:"+33 1 47 20 50 50",img:"https://cdn.shopify.com/s/files/1/0767/8237/1000/files/rolex-flagship.jpg?v=1737021398",plus:Shopify.routes.root + "pages/rolex-contact-arije-pierre-charron",tags:storeTags});
  Shop.push({lib:'Arije Saint Germain',geo:new google.maps.LatLng(48.8535013,2.333172), ad:"5 place du Québec<br>75006 Paris<br>France",tel:"+33 1 43 35 05 05",img:"https://cdn.shopify.com/s/files/1/0767/8237/1000/files/arije-saint-germain-des-pres.jpg?v=1736873070",plus:Shopify.routes.root + "pages/rolex-contact-arije-saint-germain",tags:storeTags});

  var markers= [];
  var marker, i;
  var image = 'https://cdn.shopify.com/s/files/1/0767/8237/1000/files/map-location-pin-green-button_1.png?v=1737021956';
  var image2 = 'https://cdn.shopify.com/s/files/1/0767/8237/1000/files/map-location-pin-selected-green-button_1.png?v=1737021956';

  // Let's also add a marker while we're at it
  for(i=0; i < Shop.length; i++) {
    marker = new google.maps.Marker({
      position: Shop[i].geo,
      map: map,
      icon: image
    });

    markers.push(marker);
  }

  // Ajouter un écouteur pour le clic sur les marqueurs
  markers.forEach(function(marker, i) {
    google.maps.event.addListener(marker, 'click', function() {
      marker.setIcon(image2);
      var infoContent = fillContent(Shop[i],i);
      $(document).trigger("rolex-map-loaded");
      var timeout = 0;
      if (jQuery('#showStore').hasClass('opened')) {
        timeout = 300;
      }
      jQuery("#showStore").removeClass('opened');
      window.setTimeout(function() {
        jQuery('#showStore').html(infoContent).addClass('opened');
        document.dispatchEvent(event);
        window.setTimeout(function() {
          centerMarkerWithOverlay(marker, map, true);
        }, 100);
      }, timeout);
    });
  });

  var clusterStyles = [
    {
      anchor: [19, 19],
      height: 38,
      textAlign: 'center',
      textColor: '#006039',
      textLineHeight: 38,
      textSize: 12,
      url: 'https://cdn.shopify.com/s/files/1/0767/8237/1000/files/pin-several-values.png?v=1737021750',
      width: 38
    }
  ];
  // Créez le cluster de markers
  var markerCluster = new MarkerClusterer(map, markers, {
    styles: clusterStyles,
    imagePath: '/wp-content/uploads/rolex/rolex-contact-cta-assets/png-buttons/m'
  });

  jQuery("#showStore").on("click", "#cbi",  function(){
    jQuery("#showStore").removeClass('opened');
    map.setCenter(mapOptions.center); // Recentrer la carte sur les coordonnées initiales ou le dernier marqueur cliqué
    for (var j = 0; j < markers.length; j++) {
      markers[j].setIcon(image);
    }
    smoothSetCenter(map, rolexMapsLastCenter, rolexMapsLastMarkerCenter); // Recentrer la carte sur les coordonnées mémorisées
  });

  // Réajuster le centre de la carte lorsque la fenêtre est redimensionnée
  window.addEventListener('resize', function() {
    markers.forEach(function(marker) {
      if (document.getElementById('showStore').style.display === 'block') {
        //centerMarkerWithOverlay(marker, map, true);
      }
    });
  });

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // Meme markup que les badges de la liste (.rlx-store__badges / .rlx-badge),
  // pour que la popup et la fiche boutique soient identiques.
  function renderTags(store) {
    var tags = (store.tags || []).filter(function(tag) {
      return tag && tag.label;
    });

    if (tags.length === 0) {
      return '';
    }

    var items = tags.map(function(tag) {
      var modifier = tag.style ? ' rlx-badge--' + tag.style : '';
      return '<span class="rlx-badge' + modifier + '">' + escapeHtml(tag.label) + '</span>';
    }).join('');

    return '<div class="rlx-store__badges">' + items + '</div>';
  }

  function fillContent(store,i){

    var isFrench = document.documentElement.lang == "fr";
    var directionLabel = isFrench ? "Trouver l'itinéraire" : "Find route";
    var moreLabel = isFrench ? "Plus de détails" : "More details";

    var popupHtml = `
        <img class="maps-popup-image" src="${store.img}">
        <div class="maps-popup-content">
          <button id="cbi" class="maps-close">X</button>
          ${renderTags(store)}
          <h2 class="maps-title has-headline-30-font-size has-brown wp-block-heading">${store.lib}</h2>
          <div class="maps-address has-fixed-16-font-size has-black">${store.ad}</div>
          <div class="rolex-icons rolex-icons-vertical">
            <div class="rolex-contact-icon rolex-contact-icon-phone">
              <a href="tel:${store.tel}" class="rolex-contactCall-tracking">
                <i class="rolex-icon"></i>
                <span class="label">${store.tel}</span>
              </a>
            </div>
            <div class="rolex-contact-icon rolex-contact-icon-direction">
              <a href="https://www.google.com/maps/dir/${store.geo.toUrlValue()}" target="_blank" class="rolex-getdirection-tracking">
                <i class="rolex-icon"></i>
                <span class="label">${directionLabel}</span>
              </a>
            </div>
            <div class="rolex-contact-icon rolex-contact-icon-more">
              <a href="${store.plus}" target="_self">
                <i class="rolex-icon"></i>
                <span class="label">${moreLabel}</span>
              </a>
            </div>
          </div>
        </div>
    `;

    return popupHtml;
  }
}
function ZoomControl(controlDiv, map) {

  // Set CSS for the control wrapper
  var controlWrapper = document.createElement('div');
  controlWrapper.className = 'rolex-maps-zoom-wrapper';
  controlDiv.appendChild(controlWrapper);

  // Set CSS for the zoomIn
  var zoomInButton = document.createElement('div');
  zoomInButton.className = 'rolex-maps-zoom zoom-in-btn';
  controlWrapper.appendChild(zoomInButton);

  // Set CSS for the zoomOut
  var zoomOutButton = document.createElement('div');
  zoomOutButton.className = 'rolex-maps-zoom zoom-out-btn';
  controlWrapper.appendChild(zoomOutButton);

  // Setup the click event listener - zoomIn
  google.maps.event.addDomListener(zoomInButton, 'click', function() {
    map.setZoom(map.getZoom() + 1);
  });

  // Setup the click event listener - zoomOut
  google.maps.event.addDomListener(zoomOutButton, 'click', function() {
    map.setZoom(map.getZoom() - 1);
  });  

}
// Fonction pour interpoler entre deux positions
function interpolate(start, end, factor) {
  return start + (end - start) * factor;
}

// Fonction pour animer le centrage de la carte
function smoothSetCenter(map, start, targetPosition) {
  var startLat = start.lat();
  var startLng = start.lng();
  var targetLat = targetPosition.lat();
  var targetLng = targetPosition.lng();
  var steps = 30; // Nombre d'étapes pour l'animation
  var step = 0;
  rolexMapsLastCenter = targetPosition;

  function animate() {
    step += 1;
    var factor = step / steps;
    var lat = interpolate(startLat, targetLat, factor);
    var lng = interpolate(startLng, targetLng, factor);
    map.setCenter(new google.maps.LatLng(lat, lng));
    if (step < steps) {
      requestAnimationFrame(animate);
    }
  }

  animate();
}

// Fonction pour centrer un marqueur en tenant compte de l'overlay
function centerMarkerWithOverlay(marker, map, overlayVisible) {
  var overlay = document.getElementById('showStore');
  var isMobile = window.matchMedia("(max-width: 768px)").matches;

  var mapCenter = marker.getPosition();
  rolexMapsLastMarkerCenter = mapCenter;

  if (overlayVisible) {
    if (isMobile) {
      // Centrer en tenant compte de l'overlay en bas
      var scale = Math.pow(2, map.getZoom());
      var worldCoordinateCenter = map.getProjection().fromLatLngToPoint(mapCenter);
      var pixelOffset = new google.maps.Point(0, (overlay.offsetHeight / 2) / scale);
      var worldCoordinateNewCenter = new google.maps.Point(
        worldCoordinateCenter.x,
        worldCoordinateCenter.y + pixelOffset.y
      );
      var newCenter = map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);
      smoothSetCenter(map, map.getCenter(), newCenter);
    } else {
      // Centrer en tenant compte de l'overlay à gauche
      var scale = Math.pow(2, map.getZoom());
      var worldCoordinateCenter = map.getProjection().fromLatLngToPoint(mapCenter);
      var pixelOffset = new google.maps.Point((overlay.offsetWidth / 2) / scale, 0);
      var worldCoordinateNewCenter = new google.maps.Point(
        worldCoordinateCenter.x - pixelOffset.x,
        worldCoordinateCenter.y
      );
      var newCenter = map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);
      smoothSetCenter(map, map.getCenter(), newCenter);
    }
  } else {
    // Centre normal
    smoothSetCenter(map, map.getCenter(), mapCenter);
  }
}